import { makeNetTerms } from '~/infra/translator';
import { assertUnreachable } from '~/infra/utils';
export var AmendmentDraftChangeType = /*#__PURE__*/ function(AmendmentDraftChangeType) {
    AmendmentDraftChangeType["ServiceCostUpdate"] = "serviceCostUpdate";
    AmendmentDraftChangeType["NetTermsUpdate"] = "netTermsUpdate";
    AmendmentDraftChangeType["ServiceNameUpdate"] = "serviceNameUpdate";
    AmendmentDraftChangeType["ServiceDescriptionUpdate"] = "serviceDescriptionUpdate";
    AmendmentDraftChangeType["ServiceTermsUpdate"] = "serviceTermsUpdate";
    AmendmentDraftChangeType["ServiceTermsRemoval"] = "serviceTermsRemoval";
    AmendmentDraftChangeType["ServiceBillingTriggerUpdate"] = "serviceBillingTriggerUpdate";
    AmendmentDraftChangeType["ServiceBundleUpdate"] = "serviceBundleUpdate";
    AmendmentDraftChangeType["ServiceBundleRemoval"] = "serviceBundleRemoval";
    AmendmentDraftChangeType["ServiceAddition"] = "serviceAddition";
    AmendmentDraftChangeType["ServiceTermination"] = "serviceTermination";
    AmendmentDraftChangeType["ServiceCancellation"] = "serviceCancellation";
    AmendmentDraftChangeType["ServiceIntegratedClassUpdate"] = "serviceIntegratedClassUpdate";
    AmendmentDraftChangeType["ServiceTaxabilityUpdate"] = "serviceTaxabilityUpdate";
    AmendmentDraftChangeType["PaymentApprovalRequirementUpdate"] = "paymentApprovalRequirementUpdate";
    AmendmentDraftChangeType["TaxSettingsUpdate"] = "taxSettingsUpdate";
    AmendmentDraftChangeType["CreditCardFeeCoverageUpdate"] = "creditCardFeeCoverageUpdate";
    AmendmentDraftChangeType["LegalTermsDocumentsUpdate"] = "legalTermsDocumentsUpdate";
    AmendmentDraftChangeType["AmendmentsApprovalMethodUpdate"] = "amendmentsApprovalMethodUpdate";
    AmendmentDraftChangeType["InvoicesApprovalMethodUpdate"] = "invoicesApprovalMethodUpdate";
    AmendmentDraftChangeType["CustomPageAddition"] = "customPageAddition";
    AmendmentDraftChangeType["CustomPageUpdate"] = "customPageUpdate";
    return AmendmentDraftChangeType;
}({});
export var ServiceCostConflict = /*#__PURE__*/ function(ServiceCostConflict) {
    ServiceCostConflict["PriceIncreased"] = "priceIncreased";
    ServiceCostConflict["DiscountExpired"] = "discountExpired";
    return ServiceCostConflict;
}({});
export var LastModificationType = /*#__PURE__*/ function(LastModificationType) {
    LastModificationType["NeverModified"] = "neverModified";
    LastModificationType["Modified"] = "modified";
    return LastModificationType;
}({});
export const neverModified = ()=>({
        type: "neverModified"
    });
export const modifiedBy = (modified)=>({
        type: "modified",
        modified
    });
export const lastModificationFromDTO = (dto)=>dto !== null && dto !== void 0 ? dto : neverModified();
export const modificationRecordOf = (lastModification)=>lastModification.type === "modified" ? lastModification.modified : undefined;
export function acceptAmendmentDraftChange(change, visitor) {
    switch(change.type){
        case "serviceCostUpdate":
            var _visitor_visitServiceCostUpdate;
            return (_visitor_visitServiceCostUpdate = visitor.visitServiceCostUpdate) === null || _visitor_visitServiceCostUpdate === void 0 ? void 0 : _visitor_visitServiceCostUpdate.call(visitor, change.value);
        case "netTermsUpdate":
            var _visitor_visitNetTermsUpdate;
            return (_visitor_visitNetTermsUpdate = visitor.visitNetTermsUpdate) === null || _visitor_visitNetTermsUpdate === void 0 ? void 0 : _visitor_visitNetTermsUpdate.call(visitor, change.value);
        case "serviceNameUpdate":
            var _visitor_visitServiceNameUpdate;
            return (_visitor_visitServiceNameUpdate = visitor.visitServiceNameUpdate) === null || _visitor_visitServiceNameUpdate === void 0 ? void 0 : _visitor_visitServiceNameUpdate.call(visitor, change.value);
        case "serviceDescriptionUpdate":
            var _visitor_visitServiceDescriptionUpdate;
            return (_visitor_visitServiceDescriptionUpdate = visitor.visitServiceDescriptionUpdate) === null || _visitor_visitServiceDescriptionUpdate === void 0 ? void 0 : _visitor_visitServiceDescriptionUpdate.call(visitor, change.value);
        case "serviceTermsUpdate":
            var _visitor_visitServiceTermsUpdate;
            return (_visitor_visitServiceTermsUpdate = visitor.visitServiceTermsUpdate) === null || _visitor_visitServiceTermsUpdate === void 0 ? void 0 : _visitor_visitServiceTermsUpdate.call(visitor, change.value);
        case "serviceTermsRemoval":
            var _visitor_visitServiceTermsRemoval;
            return (_visitor_visitServiceTermsRemoval = visitor.visitServiceTermsRemoval) === null || _visitor_visitServiceTermsRemoval === void 0 ? void 0 : _visitor_visitServiceTermsRemoval.call(visitor, change.value);
        case "serviceBillingTriggerUpdate":
            var _visitor_visitServiceBillingTriggerUpdate;
            return (_visitor_visitServiceBillingTriggerUpdate = visitor.visitServiceBillingTriggerUpdate) === null || _visitor_visitServiceBillingTriggerUpdate === void 0 ? void 0 : _visitor_visitServiceBillingTriggerUpdate.call(visitor, change.value);
        case "serviceBundleUpdate":
            var _visitor_visitServiceBundleUpdate;
            return (_visitor_visitServiceBundleUpdate = visitor.visitServiceBundleUpdate) === null || _visitor_visitServiceBundleUpdate === void 0 ? void 0 : _visitor_visitServiceBundleUpdate.call(visitor, change.value);
        case "serviceBundleRemoval":
            var _visitor_visitServiceBundleRemoval;
            return (_visitor_visitServiceBundleRemoval = visitor.visitServiceBundleRemoval) === null || _visitor_visitServiceBundleRemoval === void 0 ? void 0 : _visitor_visitServiceBundleRemoval.call(visitor, change.value);
        case "serviceAddition":
            var _visitor_visitServiceAddition;
            return (_visitor_visitServiceAddition = visitor.visitServiceAddition) === null || _visitor_visitServiceAddition === void 0 ? void 0 : _visitor_visitServiceAddition.call(visitor, change.value);
        case "serviceTermination":
            var _visitor_visitServiceTermination;
            return (_visitor_visitServiceTermination = visitor.visitServiceTermination) === null || _visitor_visitServiceTermination === void 0 ? void 0 : _visitor_visitServiceTermination.call(visitor, change.value);
        case "serviceCancellation":
            var _visitor_visitServiceCancellation;
            return (_visitor_visitServiceCancellation = visitor.visitServiceCancellation) === null || _visitor_visitServiceCancellation === void 0 ? void 0 : _visitor_visitServiceCancellation.call(visitor, change.value);
        case "serviceIntegratedClassUpdate":
            var _visitor_visitServiceIntegratedClassUpdate;
            return (_visitor_visitServiceIntegratedClassUpdate = visitor.visitServiceIntegratedClassUpdate) === null || _visitor_visitServiceIntegratedClassUpdate === void 0 ? void 0 : _visitor_visitServiceIntegratedClassUpdate.call(visitor, change.value);
        case "serviceTaxabilityUpdate":
            var _visitor_visitServiceTaxabilityUpdate;
            return (_visitor_visitServiceTaxabilityUpdate = visitor.visitServiceTaxabilityUpdate) === null || _visitor_visitServiceTaxabilityUpdate === void 0 ? void 0 : _visitor_visitServiceTaxabilityUpdate.call(visitor, change.value);
        case "paymentApprovalRequirementUpdate":
            var _visitor_visitPaymentApprovalRequirementUpdate;
            return (_visitor_visitPaymentApprovalRequirementUpdate = visitor.visitPaymentApprovalRequirementUpdate) === null || _visitor_visitPaymentApprovalRequirementUpdate === void 0 ? void 0 : _visitor_visitPaymentApprovalRequirementUpdate.call(visitor, change.value);
        case "taxSettingsUpdate":
            var _visitor_visitTaxSettingsUpdate;
            return (_visitor_visitTaxSettingsUpdate = visitor.visitTaxSettingsUpdate) === null || _visitor_visitTaxSettingsUpdate === void 0 ? void 0 : _visitor_visitTaxSettingsUpdate.call(visitor, change.value);
        case "creditCardFeeCoverageUpdate":
            var _visitor_visitCreditCardFeeCoverageUpdate;
            return (_visitor_visitCreditCardFeeCoverageUpdate = visitor.visitCreditCardFeeCoverageUpdate) === null || _visitor_visitCreditCardFeeCoverageUpdate === void 0 ? void 0 : _visitor_visitCreditCardFeeCoverageUpdate.call(visitor, change.value);
        case "legalTermsDocumentsUpdate":
            var _visitor_visitLegalTermsDocumentsUpdate;
            return (_visitor_visitLegalTermsDocumentsUpdate = visitor.visitLegalTermsDocumentsUpdate) === null || _visitor_visitLegalTermsDocumentsUpdate === void 0 ? void 0 : _visitor_visitLegalTermsDocumentsUpdate.call(visitor, change.value);
        case "amendmentsApprovalMethodUpdate":
            var _visitor_visitAmendmentsApprovalMethodUpdate;
            return (_visitor_visitAmendmentsApprovalMethodUpdate = visitor.visitAmendmentsApprovalMethodUpdate) === null || _visitor_visitAmendmentsApprovalMethodUpdate === void 0 ? void 0 : _visitor_visitAmendmentsApprovalMethodUpdate.call(visitor, change.value);
        case "invoicesApprovalMethodUpdate":
            var _visitor_visitInvoicesApprovalMethodUpdate;
            return (_visitor_visitInvoicesApprovalMethodUpdate = visitor.visitInvoicesApprovalMethodUpdate) === null || _visitor_visitInvoicesApprovalMethodUpdate === void 0 ? void 0 : _visitor_visitInvoicesApprovalMethodUpdate.call(visitor, change.value);
        case "customPageAddition":
            var _visitor_visitCustomPageAddition;
            return (_visitor_visitCustomPageAddition = visitor.visitCustomPageAddition) === null || _visitor_visitCustomPageAddition === void 0 ? void 0 : _visitor_visitCustomPageAddition.call(visitor, change.value);
        case "customPageUpdate":
            var _visitor_visitCustomPageUpdate;
            return (_visitor_visitCustomPageUpdate = visitor.visitCustomPageUpdate) === null || _visitor_visitCustomPageUpdate === void 0 ? void 0 : _visitor_visitCustomPageUpdate.call(visitor, change.value);
        default:
            return assertUnreachable(change);
    }
}
export function acceptAmendmentDraftChangeExhaustive(change, visitor) {
    acceptAmendmentDraftChange(change, visitor);
}
export const makeServiceCostUpdate = (serviceId, cost)=>({
        type: "serviceCostUpdate",
        value: {
            serviceId,
            cost,
            conflicts: []
        }
    });
export const makeNetTermsUpdate = (netTerms)=>({
        type: "netTermsUpdate",
        value: {
            netTerms: makeNetTerms(netTerms)
        }
    });
export const makeServiceNameUpdate = (serviceId, name)=>({
        type: "serviceNameUpdate",
        value: {
            serviceId,
            name
        }
    });
export const makeServiceDescriptionUpdate = (serviceId, description)=>({
        type: "serviceDescriptionUpdate",
        value: {
            serviceId,
            description
        }
    });
export const makeServiceTermsUpdate = (serviceId, terms)=>({
        type: "serviceTermsUpdate",
        value: {
            serviceId,
            terms
        }
    });
export const makeServiceTermsRemoval = (serviceId)=>({
        type: "serviceTermsRemoval",
        value: {
            serviceId
        }
    });
export const makeServiceBillingTriggerUpdate = (serviceId, billedUpon)=>({
        type: "serviceBillingTriggerUpdate",
        value: {
            serviceId,
            billedUpon
        }
    });
export const makeServiceBundleUpdate = (serviceId, bundle)=>({
        type: "serviceBundleUpdate",
        value: {
            serviceId,
            bundle
        }
    });
export const makeServiceBundleRemoval = (serviceId)=>({
        type: "serviceBundleRemoval",
        value: {
            serviceId
        }
    });
export const makeServiceAddition = (serviceId, service)=>({
        type: "serviceAddition",
        value: {
            serviceId,
            service
        }
    });
export const makeServiceTermination = (serviceId)=>({
        type: "serviceTermination",
        value: {
            serviceId
        }
    });
export const makeServiceCancellation = (serviceId)=>({
        type: "serviceCancellation",
        value: {
            serviceId
        }
    });
export const makeServiceIntegratedClassUpdate = (serviceId, integratedClass)=>({
        type: "serviceIntegratedClassUpdate",
        value: {
            serviceId,
            integratedClass
        }
    });
export const makeServiceTaxabilityUpdate = (serviceId, taxable)=>({
        type: "serviceTaxabilityUpdate",
        value: {
            serviceId,
            taxable
        }
    });
export const makeTaxSettingsUpdate = (taxSettings)=>({
        type: "taxSettingsUpdate",
        value: {
            taxSettings
        }
    });
export const makePaymentApprovalRequirementUpdate = (allowManualPayments)=>({
        type: "paymentApprovalRequirementUpdate",
        value: {
            allowManualPayments
        }
    });
export const makeCreditCardFeeCoverageUpdate = (coverCreditCardFees)=>({
        type: "creditCardFeeCoverageUpdate",
        value: {
            coverCreditCardFees
        }
    });
export const makeLegalTermsDocumentsUpdate = (legalTermsDocuments)=>({
        type: "legalTermsDocumentsUpdate",
        value: {
            legalTermsDocuments
        }
    });
export const makeAmendmentsApprovalMethodUpdate = (amendmentsApprovalMethod)=>({
        type: "amendmentsApprovalMethodUpdate",
        value: {
            amendmentsApprovalMethod
        }
    });
export const makeInvoicesApprovalMethodUpdate = (invoicesApprovalMethod)=>({
        type: "invoicesApprovalMethodUpdate",
        value: {
            invoicesApprovalMethod
        }
    });
export const makeCustomPageAddition = (page)=>({
        type: "customPageAddition",
        value: {
            page
        }
    });
export const makeCustomPageUpdate = (page)=>({
        type: "customPageUpdate",
        value: {
            page
        }
    });
